module.exports = __webpack_public_path__ + "img/zyjy_07.a302ce00.png";